export default {"src":"/_next/static/media/g_calendar.2f357690.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};